import React, {FunctionComponent} from "react";
import {Main} from './components/Main';


interface ISelfConfigProps {
}


export const SelfConfig: FunctionComponent<ISelfConfigProps> = function (props) {
    return <Main/>
};
